import { render, staticRenderFns } from "./ProductsPagination.vue?vue&type=template&id=fd777186&"
import script from "./ProductsPagination.vue?vue&type=script&lang=js&"
export * from "./ProductsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports